import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const ProgressBar = ({ total, current }) => {
    // Prevent divide by zero error
    if (total === 0) return null

    const currentValue = Math.round((current / total) * 100)

    return (
        <div
            style={{
                position: 'relative',
                height: '30px',
                marginBottom: '15px',
                overflow: 'hidden',
            }}
        >
            <S.ProgressBar>{`${currentValue < 100 ? currentValue : 100}% Complete`}</S.ProgressBar>
            <S.ProgressBar
                style={{
                    backgroundColor: currentValue >= 100 ? '#19C855' : '#338ce4',
                    color: '#fff',
                    clipPath: `polygon(0% 0%, ${currentValue +
                        (currentValue >= 100 ? 2 : 0)}% 0%, ${currentValue -
                        (currentValue >= 100 ? 0 : 2)}% 100%, 0% 100%)`,
                }}
            >
                {`${currentValue < 100 ? currentValue : 100}% Complete`}

                {currentValue < 100 && <S.ProgressBarAnimation />}
            </S.ProgressBar>
        </div>
    )
}

ProgressBar.propTypes = {
    total: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
}

export default ProgressBar
